import styled from "styled-components";
//@ts-ignore
import logo from "./imgs/logo.png";
//@ts-ignore
import x from "./imgs/x.png";
//@ts-ignore
import profile from "./imgs/profile.png";

//@ts-ignore
import avatar1 from "./imgs/mypage/1.png";

//@ts-ignore
import avatar2 from "./imgs/mypage/2.png";

//@ts-ignore
import avatar3 from "./imgs/mypage/3.png";

//@ts-ignore
import avatar4 from "./imgs/mypage/4.png";

//@ts-ignore
import avatar5 from "./imgs/mypage/5.png";

//@ts-ignore
import avatar6 from "./imgs/mypage/6.png";

//@ts-ignore
import avatar7 from "./imgs/mypage/7.png";

//@ts-ignore
import avatar8 from "./imgs/mypage/8.png";

//@ts-ignore
import avatar9 from "./imgs/mypage/9.png";

//@ts-ignore
import avatar10 from "./imgs/mypage/10.png";

const Header = ({
  onClickProfileModal,
}: {
  onClickProfileModal: () => void;
}) => {
  const avatarImg = () => {
    if (localStorage.getItem("profile") === "nsinu") {
      return avatar1;
    }

    if (localStorage.getItem("profile") === "nes_c_mikyung") {
      return avatar2;
    }

    if (localStorage.getItem("profile") === "njonghyun") {
      return avatar3;
    }

    if (localStorage.getItem("profile") === "njiyun") {
      return avatar4;
    }

    if (localStorage.getItem("profile") === "nes_c_sohyun") {
      return avatar5;
    }

    if (localStorage.getItem("profile") === "nwoof") {
      return avatar6;
    }

    if (localStorage.getItem("profile") === "nyoungil") {
      return avatar7;
    }

    if (localStorage.getItem("profile") === "nyuna") {
      return avatar8;
    }

    if (localStorage.getItem("profile") === "njiwon") {
      return avatar9;
    }

    if (localStorage.getItem("profile") === "nara_call") {
      return avatar10;
    } else {
      return avatar1;
    }
  };

  function windowClose() {
    // window.open("https://www.google.co.kr/", "_self")?.close();
    var ret = window.open("about:blank", "_self");
    //@ts-ignore
    ret.close();
  }

  return (
    <Wrapper>
      <button onClick={windowClose}>
        <img src={x} width={24} height={24} alt="x" />
      </button>
      <div>
        <img src={logo} width={17} height={20} alt="logo" />
        <h1>GP_AI</h1>
      </div>
      <button onClick={onClickProfileModal}>
        <img src={avatarImg()} width={48} height={48} alt="profile" />
      </button>
    </Wrapper>
  );
};

export default Header;

const Wrapper = styled.div`
  padding: 20px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f5f5;
  position: fixed;
  top: 0;
  width: 100%;
  border-bottom: 1px solid rgba(234, 234, 234, 1);
  z-index: 100;

  > button {
    border: 0;
    background-color: #f5f5f5;
  }

  > div {
    display: flex;
    justify-content: center;
    align-items: center;

    > h1 {
      font-size: 18px;
      color: rgba(28, 28, 28, 1);
      font-weight: 600;
      margin-left: 10px;
    }
  }
`;
